import * as React from "react";
import {IconProps} from "@components/Icons/IconTypes";

export const UploadIcon = React.forwardRef<SVGSVGElement, IconProps>(
    ({ size = 32, title, ...props }, ref) => {
        return (
            <svg
                ref={ref}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 35 32"
                width={size}
                height={size}
                fill="none"
                role="img"
                aria-hidden={title ? undefined : true}
                {...props}
            >
                {title && <title>{title}</title>}
                <path
                    fill="currentColor"
                    d="M35 7.6803v8.4601c0 4.2318-3.4684 7.6632-7.7434 7.6634h-1.6492l-.1333-.0068c-.6619-.0662-1.1788-.6197-1.1792-1.2921 0-.6728.5171-1.2277 1.1792-1.2939l.1333-.0051h1.6492c2.8262-.0002 5.1184-2.2694 5.1184-5.0655v-8.46c-.0001-2.8068-2.2995-5.0821-5.1355-5.0825H7.7435C4.9158 2.598 2.625 4.865 2.625 7.6634v8.4584c0 2.8088 2.298 5.0837 5.1338 5.0841h1.6338c.7247.0002 1.3125.5817 1.3125 1.299-.0005.7169-.5881 1.2987-1.3125 1.2989H7.7588C3.4728 23.8034 0 20.3649 0 16.1218V7.6634C0 3.4304 3.4662.0002 7.7434 0h19.4961C31.5252.0004 34.9999 3.4388 35 7.6803ZM18.8125 30.7011c0 .7172-.5878 1.2987-1.3125 1.2989-.7249 0-1.3125-.5816-1.3125-1.2989V12.9928l-2.8608 2.8414c-.5116.5083-1.3424.5097-1.856.0034a1.2892 1.2892 0 0 1-.0034-1.8368l5.103-5.0706A1.3201 1.3201 0 0 1 17.5 8.548c.3489 0 .6835.1376.9297.3822l5.103 5.0706.0906.0981c.4194.511.3872 1.2641-.094 1.7387-.5135.5062-1.3444.5046-1.856-.0033l-2.8608-2.8415v17.7083Z"
                />
            </svg>
        );
    }
);

UploadIcon.displayName = "UploadIcon";
